import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="reply-toggle"
export default class extends Controller {
  static targets = ["form", "input"];

  toggle(event) {
    event.preventDefault();
    this.formTarget.classList.toggle("hidden");

    // Auto-focus the input box so the keyboard pops up immediately on mobile
    if (!this.formTarget.classList.contains("hidden")) {
      this.inputTarget.focus();
    }
  }

  hide() {
    this.formTarget.classList.add("hidden");
    this.inputTarget.value = ""; // Clear the box after sending
  }
}
